import OpticksLoader from "@/components/ui/OpticksIcons/OpticksLoader";
import "./OpticksSpinner.css";
import classNames from "classnames";

interface Props {
  variation?: string;
}

const OpticksSpinner = ({ variation }: Props) => (
  <div
    className={classNames("opticks-spinner", {
      [`variation-${variation}`]: variation,
    })}
  >
    <div className="opticks-loader-spin" />
    <OpticksLoader />
  </div>
);

export default OpticksSpinner;
